import { render, staticRenderFns } from "./InvoicePrizes.vue?vue&type=template&id=4ad53ee0&"
import script from "./InvoicePrizes.vue?vue&type=script&lang=js&"
export * from "./InvoicePrizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports